import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError, ITotalItems } from '@unfoldrtech/portal-mic'
import { IReportingChartResponse } from '@unfoldrtech/portal-mic/dist/src/openapi/core/sdk/api'
import { coreAPI } from '../services/coreAPI'
import {
  generateCorrelationId,
  getTZOffset,
  getTimezone,
} from '../utils/helpers'
import {
  TAdGroupsReportChartFilters,
  TPPAdvertiserId,
  TPPRetailerId,
} from '../models/types'
import { IReportPageTypes } from '../models/interfaces'

export default function useGetV2RetailerReportingAdGroupsChart({
  retailerId,
  advertiserId,
  inventoryType,
  campaignIds,
  adGroupIds,
  timeWindow,
  startDate,
  endDate,
  tzOffset,
  tzZone,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & TAdGroupsReportChartFilters &
  TPPRetailerId &
  TPPAdvertiserId &
  IReportPageTypes): UseQueryResult<
  AxiosResponse<ITotalItems & IReportingChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdGroupsChart_${retailerId}_${advertiserId}_${
    inventoryType || ''
  }`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    ({ queryKey }) => {
      const filters = queryKey[1] || {}
      const { start, end } = filters as { start: string; end: string }

      return coreAPI
        .v2RetailerReporting()
        .getRetailerAdGroupsReportChart(
          retailerId,
          generateCorrelationId(),
          advertiserId,
          inventoryType,
          campaignIds,
          adGroupIds,
          timeWindow,
          start,
          end,
          tzOffset || getTZOffset(endDate),
          tzZone || getTimezone()
        )
    },
    { suspense, enabled }
  )
}
